export class EntStorageFilter {
  page: number;
  size: number;
  deleted: boolean;
  storageName?: string;
  regionId?: number;
  areaId?: number;
  territorialUnitId?: number;
  productType?: number;
  yearReported?: number;

  constructor(init?: Partial<EntStorageFilter>) {
	this.page = 1;
	this.size = 1000;
	this.deleted = false;
	if (init) {
	  Object.assign(this, init)
	}
  }
}
  